import { ScrollView, type ScrollViewProps } from 'react-native'

export const SettingsScreenWrapper = (props: ScrollViewProps) => (
  <ScrollView contentContainerClassName="p-4 pb-12 gap-4 max-w-screen-sm w-full mx-auto" {...props} />
)
